import React, { useEffect, useState } from "react";
import "./ClientSatisfaction.css";

// Images Import
import client1 from "../../assets/images/Clients/client1.png";
import client2 from "../../assets/images/Clients/client2.png";
import client3 from "../../assets/images/Clients/client3.png";
import client4 from "../../assets/images/Clients/client4.png";
import client5 from "../../assets/images/Clients/client5.png";

export default function ClientSatisfactionHero() {
  const testimonials = [
    { img: client2, name: "Sara Khalid", role: "Bakery Owner, Dubai" },
    { img: client1, name: "Ahmed Rahman", role: "Pharmacy Manager, Sharjah" },
    { img: client3, name: "Mohammed Javed", role: "Seafood Trader, Abu Dhabi" },
    { img: client4, name: "Fatima Hassan", role: "Catering Company, Dubai" }, // Reuse images if needed
    { img: client5, name: "Ravi Patel", role: "Dairy Distributor, UAE" },
  ];

  const DURATION = 3500;
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, DURATION);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  return (
    <section className="cs-hero-section">
      <div className="cs-bg-circle-lg"></div>
      <div className="cs-bg-circle-sm"></div>

      <div className="cs-container" data-aos="fade-left" data-aos-delay="400">
        <div className="cs-hero-content">
          <div className="cs-hero-badge">500+ satisfied clients</div>
          <h2 className="cs-hero-title">
            Trusted Chiller<br />Transport <span>Dubai & UAE</span>
          </h2>
          <p className="cs-hero-description">
            Reliable refrigerated trucks and vans for daily or monthly rental.
            Serving businesses across UAE with temperature-sensitive cargo solutions.
          </p>
          <a className="btn--primary bg-light text-dark" href="tel:+971544792905">Call Now</a>
        </div>

        <div className="cs-hero-visual" data-aos="fade-right" data-aos-delay="400">
          <div className="cs-testimonial-wrapper">
            {testimonials.map((t, i) => (
              <div
                key={i}
                className={`cs-testimonial-card ${
                  i === activeIndex ? "cs-active" : i < activeIndex ? "cs-exit" : ""
                }`}
              >
                <div className="cs-avatar-container">
                  <img src={t.img} alt={t.name} className="cs-client-img" />
                </div>
                <p className="cs-client-name">{t.name}</p>
                <p className="cs-client-role">{t.role}</p>
              </div>
            ))}
          </div>

          {/* <div className="cs-pagination-dots">
            {testimonials.map((_, i) => (
              <button
                key={i}
                className={`cs-dot ${i === activeIndex ? "cs-active" : ""}`}
                onClick={() => setActiveIndex(i)}
              />
            ))}
          </div> */}
        </div>
      </div>

      <div className="cs-progress-container">
        <div
          className="cs-progress-bar-fill"
          key={activeIndex}
          style={{ transition: `width ${DURATION}ms linear`, width: "100%" }}
        ></div>
      </div>
    </section>
  );
}
